import * as RolesModels from '../../models/roles/role';

export class Get {
  static readonly type = '[ClientRole] Get';
  constructor(public RoleId: number) {}
}

export class Set {
  static readonly type = '[ClientRole] Set';
  constructor(public Role: RolesModels.RoleModel) { }
}

export class GetList {
  static readonly type = '[ClientRole] List';
  constructor() { }
}

export class Delete {
  static readonly type = '[ClientRole] Delete';
  constructor(public RoleId: number) { }
}

